import { HGroup } from "../area/HGroup";
import { VGroup } from "../area/VGroup";

import { SC_Input } from "../input/SC_Input";

import { RoofType } from "../roof/RoofType";

import { ModList } from "../panel/ModList";
import { Modul } from "../panel/Modul";
import { Dyn } from "../utilities/dyn";
import { MountingSystem } from "./MountingSystem";
export class Sol50Integrated {
	//in cm
	public static nRandLeftRight: number = 45;
	//in cm
	public static nRandLeft: number = 22.5;
	//in cm
	public static nRandRight: number = 22.5;
	//in cm
	public static nRandTop: number = 30;
	//in cm
	public static nRandBottom: number = 30;
	//in cm
	public static nGroupDistance: number = 20;
	public static aHGroups: any[] = new Array();
	public static aVGroups: any[] = new Array();
	//Stückliste
	//Horizontalsteckprofil, HProfil
	public static uiHProfilCol: string = '#808080';
	//in cm
	public static nHProfilHeight: number = 9.6;
	//Length PE
	public static nHProfilLen: number;
	//Variable
	public static sHProfilVar: string;
	//get amount
	public static getHProfil(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTotLen: number;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nTotLen = (vgroupTmp.iCnt + 1) * vgroupTmp.width;
			// Horizontalprofil - Praxis - Korrektur - Faktor
			nTotLen += nTotLen * Dyn.HP_PR_CO_FA;
			iResult += Math.ceil(nTotLen / Sol50Integrated.nHProfilLen);
		}
		return iResult;
	}

	//Abschluss-Steckblende, AbschSteck
	public static uiAbschSteckCol: number = 0xa36556;
	//in cm
	public static nAbschSteckHeight: number = 4.8;
	//in cm
	public static nAbschSteckLen: number = 200;
	//Variable
	public static sAbschSteckVar: string;
	//get amount
	public static getAbschSteck(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTotLen: number;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nTotLen = vgroupTmp.width * 2;
			//Horizontalprofil-Praxis-Korrektur-Faktor
			nTotLen += nTotLen * Dyn.HP_PR_CO_FA;
			iResult += Math.ceil(nTotLen / Sol50Integrated.nAbschSteckLen);
		}
		return iResult;
	}

	//Dachtrapezprofil
	public static nTraProTopExt: number = 30;
	//get height
	public static TraPro_calcHeight(_height: number): number {
		return _height + Sol50Integrated.nTraProTopExt;
	}

	//Dachtrapezprofil 2m schwarz, SAMTrapez2m
	//Variable
	public static sSAMTrapez2mVar: string = "IDTRAPEZSW2m";
	//Überlappung
	public static nSAMTrapez2mUL: number = 20;
	//get amount
	public static getSAMTrapez2m(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTraProHeight: number;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nTraProHeight = Sol50Integrated.TraPro_calcHeight(vgroupTmp.height);
			if ((nTraProHeight / 185) - Math.floor(nTraProHeight / 185) >= 0.5) {
				iResult += Math.ceil(nTraProHeight / 185) * Math.ceil(vgroupTmp.width / 110);
			} else {
				iResult += Math.floor(nTraProHeight / 185) * Math.ceil(vgroupTmp.width / 110);
			}
		}
		return iResult;
	}

	//Dachtrapezprofil 1m schwarz, SAMTrapez1m
	//Variable
	public static sSAMTrapez1mVar: string = "IDTRAPEZSW1m";
	//get amount
	public static getSAMTrapez1m(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTraProHeight: number;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nTraProHeight = Sol50Integrated.TraPro_calcHeight(vgroupTmp.height);
			if ((nTraProHeight / 185) - Math.floor(nTraProHeight / 185) <= 0.5) {
				iResult += Math.ceil(vgroupTmp.width / 110);
			}
		}
		return iResult;
	}

	//Profilfüller schwarz 18/160, Profueller18160
	//Variable
	public static sProfueller18160Var: string = "IDPROFUELLSW18-160";
	//get amount
	public static getProfueller18160(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.width / 110);
		}
		return iResult;
	}

	//Kehldichtstreifen 60mm sw, KehlDS
	//Variable
	public static sKehlDSVar: string = "IDKEHLSTRSW60mm";
	//get amount
	public static getKehlDS(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.height / 100) * 2 + Math.ceil(vgroupTmp.width / 100);
		}
		return iResult;
	}

	//Seitliches Eindeckblech, Eindeckblech
	public static uiEindeckblechCol: string = "#f3cc92";
	//Querschnitt in cm
	public static nEindeckblechQS: number = 30;
	//Zusatzhöhe in cm
	public static nEindeckblechZusatz: number = 15;
	//Variable
	public static sEindeckblechVar: string;
	//get amount
	public static getEindeckblech(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil(((vgroupTmp.height + 30) / 185) * 2);
		}
		return iResult;
	}

	//Seitl.-Abschlussblech 65mm, AbschBlech
	//Variable
	public static sAbschBlechVar: string;
	//get amount
	public static getAbschBlech(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.height / 185) * 2);
		}
		return iResult;
	}

	//Unteres Lüftungsklemmprofil, TraufLuftProf
	//Variable
	public static sTraufLuftProfVar: string;
	//get amount
	public static getTraufLuftProf(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.width / 200);
		}
		return iResult;
	}

	//H-Abschlusskappe / Eloxal-Schwarz, HAbschKapES
	//Variable
	public static sHAbschKapESVar: string;
	//get amount
	public static getHAbschKapES(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil(((vgroupTmp.iCnt + 1) / 10) * 2);
		}
		return iResult;
	}

	//Obergurt-Bohrschraube (VPE 50St.), EdelBohr
	//Variable
	public static sEdelBohrVar: string = "IDOBERBOHRHOLZ50";
	//get amount
	public static getEdelBohr(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil((((vgroupTmp.width / 35) * (vgroupTmp.iCnt + 1)) * 2) / 50);
		}
		return iResult;
	}

	//Alu/Stahl Schraube 6,3x22 (VPE 100St.), BohrSchr
	//Variable
	public static sBohrSchrVar: string = "BOHRSR-AS-100";
	//VPE
	public static nBohrSchrVPE: number = 100;
	//get amount
	public static getBohrSchr(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		if (Sol50Integrated.sBohrSchrVar == "") {
			return 0;
		}
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += ((vgroupTmp.width * (vgroupTmp.iCnt + 1)) / 35) * 2;
		}
		return iResult;
	}

	//Kabelnetz Anschlussleitungen, KabFanNet
	//Variable
	public static sKabFanNetVar: string;
	//Merkvariable: Bohrschraubenanzahl für Kabelfangnetz
	public static iKabFanNetBS: number;
	//get amount
	public static getKabFanNet(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.width * vgroupTmp.iCnt) / 1400);
		}
		return iResult;
	}
 static getKabFanNetAndBohrSchrString(): string {
		var sRet: string;
		var iKabFanNetCnt: number;
		var iBohrVA6322Cnt: number;
		var sBohrVA6322Var: string;
		var iBohrSchrCnt: number;
		var sSeperator: string;
		sBohrVA6322Var = Sol50Integrated.sBohrSchrVar;
		if (Sol50Integrated.sKabFanNetVar == "") {
			iKabFanNetCnt = 0;
		} else {
			iKabFanNetCnt = Sol50Integrated.getKabFanNet();
		}
		iBohrVA6322Cnt = iKabFanNetCnt * 20;
		Sol50Integrated.iKabFanNetBS = iBohrVA6322Cnt;
		iBohrSchrCnt = Sol50Integrated.getBohrSchr();
		if (sBohrVA6322Var == Sol50Integrated.sBohrSchrVar) {
			iBohrVA6322Cnt += iBohrSchrCnt;
			iBohrVA6322Cnt = Math.ceil(iBohrVA6322Cnt / Sol50Integrated.nBohrSchrVPE);
			iBohrSchrCnt = 0;
		} else {
			iBohrVA6322Cnt = Math.ceil(iBohrVA6322Cnt / Sol50Integrated.nBohrSchrVPE);
			iBohrSchrCnt = Math.ceil(iBohrSchrCnt / Sol50Integrated.nBohrSchrVPE);
		}
		sSeperator = "";
		sRet = "";
		if (iKabFanNetCnt > 0) {
			sRet += sSeperator + Sol50Integrated.sKabFanNetVar + ":" + iKabFanNetCnt.toString();
			sSeperator = "|";
		}
		if (iBohrVA6322Cnt > 0) {
			sRet += sSeperator + sBohrVA6322Var + ":" + iBohrVA6322Cnt.toString();
			sSeperator = "|";
		}
		if (iBohrSchrCnt > 0) {
			sRet += sSeperator + Sol50Integrated.sBohrSchrVar + ":" + iBohrSchrCnt.toString();
			sSeperator = "|";
		}
		return sRet;
	}

	//Vertikaldichtung, VDichtS
	//Variable
	public static sVDichtSVar: string;
	//get amount
	public static getVDichtS(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.height * (vgroupTmp.iCol - 1)) / 100);
		}
		return iResult;
	}

	// Bitumenband 1,5x100  (Rolle 10m), BitBandAlu10m
	//Variable
	public static sBitBandAlu10mVar: string = "BITBAND1,5-100-10m";
	//get amount
	public static getBitBandAlu10m(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nHPLen: number;
		var nPieceCnt: number;
		nPieceCnt = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nHPLen = vgroupTmp.width * (vgroupTmp.iCnt + 1);
			nPieceCnt += Math.ceil(nHPLen / 20);
		}
		//für Kabelnetz-Bohrschrauben
		nPieceCnt += Sol50Integrated.iKabFanNetBS;
		iResult = Math.ceil((nPieceCnt * 3.5) / 1000);
		return iResult;
	}

	//SOL-Guard-Modulschloss, SOLGuard
	//Variable
	public static sSOLGuardVar: string = "GUARD1";
	//get amount
	public static getSOLGuard(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += (vgroupTmp.iCol + 1) * vgroupTmp.iCnt;
		}
		return iResult;
	}

	//VA-Erdungsset für Solargenerator, Erdbausatz
	//Variable
	public static sErdbausatzVar: string = "ERDSET1";
	//get amount
	public static getErdbausatz(): number {
		return Sol50Integrated.aVGroups.length;
	}

	//Oberes Abschlussblech, TopAbschlussblech
	public static uiTopAbschlussblechCol: string = '#905022';
	//Querschnitt in cm
	public static nTopAbschlussblechQS: number = 30;
	//Zusatzbreite in cm
	public static nTopAbschlussblechZusatz: number = 15;
	//Variable
	public static sTopAbschlussblechVar: string;
	//get amount
	public static getTopAbschlussblech(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.width - 15) / 185);
		}
		return iResult;
	}

	//Oberes Lüftungsklemmprofil, LuKam
	public static uiLuKamCol: number = 0x905022;
	//VPE
	public static nLuKamVPE: number = 200;
	//Variable
	public static sLuKamVar: string;
	//get amount
	public static getLuKam(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.width / Sol50Integrated.nLuKamVPE);
		}
		return iResult;
	}
	//Anschlussklebeband, AnKleBan
	public static uiAnKleBanCol: number = 0x905022;
	//VPE
	public static nAnKleBanVPE: number = 100;
	//Variable
	public static sAnKleBanVar: string;
	//get amount
	public static getAnKleBan(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			//100 cm for margin
			iResult += Math.ceil((vgroupTmp.width + 100) / Sol50Integrated.nAnKleBanVPE);
		}
		return iResult;
	}
	//Dichtband, Dichtband
	public static uiDichtbandCol: number = 0x905022;
	//VPE
	public static nDichtbandVPE: number = 2500;
	//Variable
	public static sDichtbandVar: string;
	//get amount
	public static getDichtband(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nThreePercent: number;
		var iDichtBandReihen: number;
		var nTraProHeight: number;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nTraProHeight = Sol50Integrated.TraPro_calcHeight(vgroupTmp.height);
			nThreePercent = vgroupTmp.width * 0.03;
			//TODO: Reihen wegen 1m und 2m überprüfen
			iDichtBandReihen = Math.floor(nTraProHeight / 185);
			iResult += Math.ceil((iDichtBandReihen * (vgroupTmp.width + nThreePercent)) / Sol50Integrated.nDichtbandVPE);
		}
		return iResult;
	}
	//Dichtband5_6, Dichtband5_6
	//VPE
	public static nDichtband5_6VPE: number = 560;
	//Variable
	public static sDichtband5_6Var: string = "IDDICHTBAND5_6";
	//get amount
	public static getDichtband5_6(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nLen: number;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			vgroupTmp = Sol50Integrated.aVGroups[i];
			nLen = (vgroupTmp.height * 2) + vgroupTmp.width;
			iResult += Math.ceil(nLen / Sol50Integrated.nDichtband5_6VPE);
		}
		return iResult;
	}

	//Eckanschluss-Set, EckAns
	//VPE
	public static nEckAnsVPE: number = 1;
	//Variable
	public static sEckAnsVar: string;
	//get amount
	public static getEckAns(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
			iResult += 1;
		}
		return iResult;
	}

	//Haften-Klemmhalter, HafKleHal
	//VPE
	public static nHafKleHalVPE: number = 50;
	//Variable
	public static sHafKleHalVar: string;
	//get amount
	public static getHafKleHal(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		iResult += Math.ceil((Sol50Integrated.getTopAbschlussblech() * 3 + Sol50Integrated.getEindeckblech() * 4 + 4) / Sol50Integrated.nHafKleHalVPE);
		return iResult;
	}

	//Distanzadapter, DistAdap
	//Variable
	public static sDistAdapVar: string = "";
	//VPE
	public static nDistAdapVPE: number = 50;
	//get amount
	public static getDistAdap(): number {
		var i: number;
		var hgroupTmp: HGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50Integrated.aHGroups.length; i++) {
			hgroupTmp = Sol50Integrated.aHGroups[i];
			iResult += (hgroupTmp.iCnt * 2) + 2;
		}
		iResult = Math.ceil(iResult / Sol50Integrated.nDistAdapVPE);
		return iResult;
	}

	//Alle zusammen
	public static getAllInString(): string {
		var sRes: string = "";
		sRes += Sol50Integrated.sHProfilVar + ":" + Sol50Integrated.getHProfil() + "|";
		sRes += Sol50Integrated.sAbschSteckVar + ":" + Sol50Integrated.getAbschSteck() + "|";
		sRes += Sol50Integrated.sSAMTrapez2mVar + ":" + Sol50Integrated.getSAMTrapez2m() + "|";
		sRes += Sol50Integrated.sSAMTrapez1mVar + ":" + Sol50Integrated.getSAMTrapez1m() + "|";
		sRes += Sol50Integrated.sProfueller18160Var + ":" + Sol50Integrated.getProfueller18160() + "|";
		switch (SC_Input.iRoofType) {
			case RoofType.SLATED:
			case RoofType.PLAIN_TILED:
				sRes += Sol50Integrated.sDichtband5_6Var + ":" + Sol50Integrated.getDichtband5_6() + "|";
				break;
			default:
				sRes += Sol50Integrated.sKehlDSVar + ":" + Sol50Integrated.getKehlDS() + "|";
		}
		sRes += Sol50Integrated.sEindeckblechVar + ":" + Sol50Integrated.getEindeckblech() + "|";
		sRes += Sol50Integrated.sAbschBlechVar + ":" + Sol50Integrated.getAbschBlech() + "|";
		sRes += Sol50Integrated.sTraufLuftProfVar + ":" + Sol50Integrated.getTraufLuftProf() + "|";
		sRes += Sol50Integrated.sHAbschKapESVar + ":" + Sol50Integrated.getHAbschKapES() + "|";
		sRes += Sol50Integrated.sEdelBohrVar + ":" + Sol50Integrated.getEdelBohr() + "|";
		sRes += Sol50Integrated.sVDichtSVar + ":" + Sol50Integrated.getVDichtS() + "|";
		sRes += Sol50Integrated.getKabFanNetAndBohrSchrString() + "|";
		sRes += Sol50Integrated.sBitBandAlu10mVar + ":" + Sol50Integrated.getBitBandAlu10m() + "|";
		sRes += Sol50Integrated.sErdbausatzVar + ":" + Sol50Integrated.getErdbausatz() + "|";
		sRes += Sol50Integrated.sTopAbschlussblechVar + ":" + Sol50Integrated.getTopAbschlussblech() + "|";
		sRes += Sol50Integrated.sLuKamVar + ":" + Sol50Integrated.getLuKam() + "|";
		sRes += Sol50Integrated.sAnKleBanVar + ":" + Sol50Integrated.getAnKleBan() + "|";
		sRes += Sol50Integrated.sDichtbandVar + ":" + Sol50Integrated.getDichtband() + "|";
		sRes += Sol50Integrated.sEckAnsVar + ":" + Sol50Integrated.getEckAns() + "|";
		sRes += Sol50Integrated.sHafKleHalVar + ":" + Sol50Integrated.getHafKleHal() + "|";
		if (Sol50Integrated.sDistAdapVar != "") {
			sRes += Sol50Integrated.sDistAdapVar + ":" + Sol50Integrated.getDistAdap() + "|";
		}
		sRes += Sol50Integrated.sSOLGuardVar + ":" + Sol50Integrated.getSOLGuard() + "|";
		return sRes;
	}
	private static getRow(aMod: any[], iStart: number) {
		var oMod: Modul;
		var oMod2: Modul;
		var aModResult: any[];
		var i: number, j: number;
		var nYDif: number;
		if (aMod.length <= iStart) {
			// return null;
		}
		// oMod = Modul(aMod[iStart]);
		// j = 1;
		// for (i = iStart + 1; i < aMod.length; i++) {
		// 	oMod2 = Modul(aMod[i]);
		// 	nYDif = oMod2.y - oMod.y;
		// 	if (nYDif < this.Global.nModAbstTol && nYDif > -this.Global.nModAbstTol) {
		// 		j++;
		// 		//valid
		// 	} else {
		// 		break;
		// 	}
		// }
		// aModResult = new Array(j);
		// for (i = 0; i < j; i++) {
		// 	aModResult[i] = aMod[i + iStart];
		// }
		// return aModResult;
	}
	private static getCol(aGroups: any[], iStart: number) {
		var hgroupTmp: HGroup;
		var hgroupTmp2: HGroup;
		var aModResult: any[];
		var i: number, j: number;
		var nXDif: number;
		if (aGroups.length <= iStart) {
			// return null;
		}
		// hgroupTmp = HGroup(aGroups[iStart]);
		// j = 1;
		// for (i = iStart + 1; i < aGroups.length; i++) {
		// 	hgroupTmp2 = HGroup(aGroups[i]);
		// 	nXDif = hgroupTmp2.x - hgroupTmp.x;
		// 	if (nXDif < this.Global.nModAbstTol && nXDif > -this.Global.nModAbstTol) {
		// 		j++;
		// 		//valid
		// 	} else {
		// 		break;
		// 	}
		// }
		// aModResult = new Array(j);
		// for (i = 0; i < j; i++) {
		// 	aModResult[i] = aGroups[i + iStart];
		// }
		// return aModResult;
	}
	private static getHGroup(aMod: any[], iStart: number) {
		var oMod: Modul;
		var oMod2: Modul;
		var hgroupResult: HGroup;
		var i: number, j: number;
		var nXDif: number;
		if (aMod.length <= iStart) {
			// return null;
		}
		// oMod = Modul(aMod[iStart]);
		// j = 1;
		// for (i = iStart + 1; i < aMod.length; i++) {
		// 	oMod2 = Modul(aMod[i]);
		// 	nXDif = oMod2.x - (oMod.x + oMod.width + this.Sol50.nHorizontalAbstand);
		// 	if (nXDif < this.Global.nModAbstTol && nXDif > -this.Global.nModAbstTol && oMod.height == oMod2.height) {
		// 		//valid
		// 		j++;
		// 	} else {
		// 		break;
		// 	}
		// 	oMod = oMod2;
		// }
		// oMod = Modul(aMod[iStart]);
		// hgroupResult = new HGroup();
		// hgroupResult.iCnt = j;
		// hgroupResult.nModWith = oMod.width;
		// hgroupResult.height = oMod.height;
		// hgroupResult.width = ((oMod.width + this.Sol50.nHorizontalAbstand) * j) - this.Sol50.nHorizontalAbstand;
		// hgroupResult.x = oMod.x;
		// hgroupResult.y = oMod.y;
		// return hgroupResult;
	}
	//get vertical group
	private static getVGroup(aGroups: any[], iStart: number) {
		var hgroupTmp: HGroup;
		var hgroupTmp2: HGroup;
		var vgroupResult: VGroup;
		var i: number, j: number;
		var nYDif: number;
		if (aGroups.length <= iStart) {
			// return null;
		}
		// hgroupTmp = HGroup(aGroups[iStart]);
		// j = 1;
		// for (i = iStart + 1; i < aGroups.length; i++) {
		// 	hgroupTmp2 = HGroup(aGroups[i]);
		// 	nYDif = hgroupTmp2.y - (hgroupTmp.y + hgroupTmp.height + this.Sol50.nVertikalAbstand);
		// 	if (nYDif < this.Global.nModAbstTol && nYDif > -this.Global.nModAbstTol && hgroupTmp2.width == hgroupTmp.width) {
		// 		j++;
		// 		hgroupTmp = hgroupTmp2;
		// 	} else {
		// 		break;
		// 	}
		// }
		// hgroupTmp = HGroup(aGroups[iStart]);
		// vgroupResult = new VGroup();
		// vgroupResult.iCnt = j;
		// vgroupResult.iCol = hgroupTmp.iCnt;
		// vgroupResult.nModWith = hgroupTmp.nModWith;
		// vgroupResult.height = ((hgroupTmp.height + this.Sol50.nVertikalAbstand) * j) - this.Sol50.nVertikalAbstand;//hgroupTmp.height;
		// //mit Vertikalabschlussblende
		// vgroupResult.height += this.Sol50.nVertikalAbschluss;
		// vgroupResult.width = hgroupTmp.width;
		// vgroupResult.x = hgroupTmp.x;
		// vgroupResult.y = hgroupTmp.y;
		// //mit Vertikalabschlussblende
		// vgroupResult.y -= (this.Sol50.nVertikalAbschluss / 2);
		// return vgroupResult;
	}
	private static getGroups(): void {
		// var aCol: any[];
		// var vgroupTmp: VGroup;
		// var i: number, j: number, iInvalid: number;
		// var iCurrent: number, iCurrent2: number;
		// var iLen: number, iLen2: number;
		// Sol50Integrated.aHGroups.sortOn("x", Array.NUMERIC);
		// iCurrent = 0;
		// iLen = Sol50Integrated.aHGroups.length;
		// if (Sol50Integrated.aVGroups.length > 0) {
		// 	Sol50Integrated.aVGroups = new Array();
		// }
		// while (iCurrent < iLen) {
		// 	aCol = Sol50Integrated.getCol(Sol50Integrated.aHGroups, iCurrent);
		// 	iCurrent += aCol.length;
		// 	aCol.sortOn("y", Array.NUMERIC);
		// 	iCurrent2 = 0;
		// 	iLen2 = aCol.length;
		// 	while (iCurrent2 < iLen2) {
		// 		vgroupTmp = Sol50Integrated.getVGroup(aCol, iCurrent2);
		// 		iCurrent2 += vgroupTmp.iCnt;
		// 		Sol50Integrated.aVGroups.push(vgroupTmp);
		// 	}
		// }
	}
	//get horizontal groups
	public static getHGroups(): void {

		// 		var oMod: Modul;
		// 		var oMod2: Modul;
		// 		var aMod: any[];
		// 		var aModRow: any[];
		// 		var hgroupTmp: HGroup;
		// 		var i: number, j: number, iInvalid: number;
		// 		var iCurrent: number, iCurrent2: number;
		// 		var iLen: number, iLen2: number;
		// 		aMod = new Array(ModList.iCount);
		// 		i = 0;
		// 		for each(oMod in ModList.dicMod) {
		// 			aMod[i] = oMod;
		// 			i++;
		// 			}
		// 	aMod.sortOn("y", Array.NUMERIC);
		// 	iCurrent = 0;
		// 	iLen = aMod.length;
		// 	if(Sol50Integrated.aHGroups.length > 0) {
		// 	Sol50Integrated.aHGroups = new Array();
		// }
		// while (iCurrent < iLen) {
		// 	aModRow = Sol50Integrated.getRow(aMod, iCurrent);
		// 	iCurrent += aModRow.length;
		// 	aModRow.sortOn("x", Array.NUMERIC);
		// 	iCurrent2 = 0;
		// 	iLen2 = aModRow.length;
		// 	while (iCurrent2 < iLen2) {
		// 		hgroupTmp = Sol50Integrated.getHGroup(aModRow, iCurrent2);
		// 		iCurrent2 += hgroupTmp.iCnt;
		// 		Sol50Integrated.aHGroups.push(hgroupTmp);
		// 	}
		// }
	}
	//HGroups zeichnen
	public static drawHGroups(): void {
		// var i: number;
		// var hgroupTmp: HGroup;
		// var lblTmp: Label;
		// this.Global.pageDesign.canFramework.removeAllChildren();
		// this.Global.pageDesign.canFramework.graphics.clear();
		// var sCol: string = "";
		// for (i = 0; i < Sol50Integrated.aHGroups.length; i++) {
		// 	hgroupTmp = HGroup(Sol50Integrated.aHGroups[i]);
		// 	var nMax: number, nMin: number;
		// 	nMin = 0x000000;
		// 	nMax = 0xffffff;
		// 	nMin = Math.floor(Math.random() * (nMax - nMin + 1)) + nMin;
		// 	this.Global.pageDesign.canFramework.graphics.beginFill(nMin, 0.5);
		// 	this.Global.pageDesign.canFramework.graphics.drawRect(hgroupTmp.x, hgroupTmp.y, hgroupTmp.width, hgroupTmp.height);
		// 	this.Global.pageDesign.canFramework.graphics.endFill();
		// 	lblTmp = new Label();
		// 	var sTmp: string = nMin.toString(16);
		// 	while (sTmp.length < 6) {
		// 		sTmp = "0" + sTmp;
		// 	}
		// 	sTmp = "0x" + sTmp;
		// 	sCol += sTmp + "\n";
		// 	lblTmp.text = sTmp;
		// 	lblTmp.x = hgroupTmp.x;
		// 	lblTmp.y = hgroupTmp.y;
		// 	lblTmp.width = 200;
		// 	lblTmp.setStyle("color", 0xffffff);
		// 	lblTmp.setStyle("fontSize", 40);
		// 	this.Global.pageDesign.canFramework.addChild(lblTmp);
		// }
		// //			System.setClipboard(sCol);
	}
	//VGroups zeichnen
	private static drawVGroup(vgroupTmp: VGroup, _index: number = -1, _color: number = -1): void {
		// var lblTmp: Label;
		// var nMax: number, nMin: number;
		// if (_color == -1) {
		// 	nMin = 0x000000;
		// 	nMax = 0xffffff;
		// 	_color = Math.floor(Math.random() * (nMax - nMin + 1)) + nMin;
		// }
		// this.Global.pageDesign.canFramework.graphics.beginFill(_color);
		// this.Global.pageDesign.canFramework.graphics.drawRect(vgroupTmp.x - 5, vgroupTmp.y, vgroupTmp.width + 10, vgroupTmp.height);
		// this.Global.pageDesign.canFramework.graphics.endFill();
		// if (_index != -1) {
		// 	lblTmp = new Label();
		// 	lblTmp.text = _index.toString();
		// 	lblTmp.x = vgroupTmp.x;
		// 	lblTmp.y = vgroupTmp.y;
		// 	lblTmp.width = 100;
		// 	lblTmp.setStyle("color", 0xffffff);
		// 	lblTmp.setStyle("fontSize", 40);
		// 	this.Global.pageDesign.canFramework.addChild(lblTmp);
		// }
	}
	public static drawVGroups(): void {
		// var i: number;
		// var vgroupTmp: VGroup;
		// this.Global.pageDesign.canFramework.removeAllChildren();
		// this.Global.pageDesign.canFramework.graphics.clear();
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	Sol50Integrated.drawVGroup(vgroupTmp, i);
		// }
	}
	//check aVGroups
	private static check_VGroup(vgroupTmp1: VGroup, iStart: number, iLen: number): boolean {
		// var nTop1: number, nBottom1: number;
		// var nLeft1: number, nRight1: number;
		// var nTop2: number, nBottom2: number;
		// var nLeft2: number, nRight2: number;
		// var vgroupTmp2: VGroup;
		// var nHTmp: number, nVTmp: number;
		// var nYDistance: number, nXDistance: number;
		// nTop1 = vgroupTmp1.y - Sol50Integrated.nRandTop;
		// nBottom1 = vgroupTmp1.y + vgroupTmp1.height;
		// nLeft1 = vgroupTmp1.x - Sol50Integrated.nRandLeft;
		// nRight1 = vgroupTmp1.x + vgroupTmp1.width + Sol50Integrated.nRandRight;
		// for (; iStart < iLen; iStart++) {
		// 	vgroupTmp2 = VGroup(Sol50Integrated.aVGroups[iStart]);
		// 	nTop2 = vgroupTmp2.y - Sol50Integrated.nRandTop;
		// 	nBottom2 = vgroupTmp2.y + vgroupTmp2.height;
		// 	nLeft2 = vgroupTmp2.x - Sol50Integrated.nRandLeft;
		// 	nRight2 = vgroupTmp2.x + vgroupTmp2.width + Sol50Integrated.nRandRight;
		// 	if (nLeft2 < nRight1) {
		// 		//y distance check
		// 		if (nTop2 > nTop1) {
		// 			if (nTop2 - nBottom1 < 0) {
		// 				RoofShape.drawHighlightIndach(vgroupTmp1, 0xff0000);
		// 				RoofShape.drawHighlightIndach(vgroupTmp2, 0xff5500);
		// 				return false;
		// 			}
		// 		} else {
		// 			if (nTop1 - nBottom2 < 0) {
		// 				RoofShape.drawHighlightIndach(vgroupTmp1, 0xff0000);
		// 				RoofShape.drawHighlightIndach(vgroupTmp2, 0xff5500);
		// 				return false;
		// 			}
		// 		}
		// 	} else {
		// 		break;
		// 	}
		// }
		return true;
	}
	private static check_aVGroups(): boolean {
		var vgroupTmp1: VGroup;
		var i: number, j: number;
		var iLen: number;
		var bRet: boolean;
		iLen = Sol50Integrated.aVGroups.length;
		bRet = true;
		if (iLen == 0) return bRet;
		//aVGroups was sorted by x
		// for (i = 0; i < iLen; i++) {
		// 	j = i + 1;
		// 	if (j < iLen) {
		// 		bRet = Sol50Integrated.check_VGroup(VGroup(Sol50Integrated.aVGroups[i]), j, iLen);
		// 		if (!bRet) break;
		// 	}
		// }
		return bRet;
	}
	//Eindeckblech zeichnen
	public static drawEindeckblech(): void {
		var i: number;
		var vgroupTmp: VGroup;
		var nY: number;
		var nX: number;
		var nHeight: number;
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	nHeight = vgroupTmp.height + Sol50Integrated.nEindeckblechZusatz;
		// 	//Left
		// 	nX = vgroupTmp.x - Sol50Integrated.nRandLeft;
		// 	nY = vgroupTmp.y - (Sol50Integrated.nEindeckblechZusatz / 2);
		// 	this.Global.pageDesign.canFramework.graphics.beginFill(Sol50Integrated.uiEindeckblechCol);
		// 	this.Global.pageDesign.canFramework.graphics.drawRect(nX, nY, Sol50Integrated.nEindeckblechQS, nHeight);
		// 	this.Global.pageDesign.canFramework.graphics.endFill();
		// 	//Right
		// 	nX = ((vgroupTmp.x + vgroupTmp.width) - Sol50Integrated.nEindeckblechQS) + Sol50Integrated.nRandRight;
		// 	nY = vgroupTmp.y - (Sol50Integrated.nEindeckblechZusatz / 2);
		// 	this.Global.pageDesign.canFramework.graphics.beginFill(Sol50Integrated.uiEindeckblechCol);
		// 	this.Global.pageDesign.canFramework.graphics.drawRect(nX, nY, Sol50Integrated.nEindeckblechQS, nHeight);
		// 	this.Global.pageDesign.canFramework.graphics.endFill();
		// }
	}
	public static drawEindeckblechPDF(): void {
		// var i: number;
		// var vgroupTmp: VGroup;
		// var nHeight: number;
		// var rTmp: Rectangle = new Rectangle();
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	nHeight = vgroupTmp.height + Sol50Integrated.nEindeckblechZusatz;
		// 	//Left
		// 	rTmp.x = (vgroupTmp.x - Sol50Integrated.nRandLeft) * this.SysPDF.nPdfFactor;
		// 	rTmp.y = (vgroupTmp.y - (Sol50Integrated.nEindeckblechZusatz / 2)) * this.SysPDF.nPdfFactor;
		// 	rTmp.width = Sol50Integrated.nEindeckblechQS * this.SysPDF.nPdfFactor;
		// 	rTmp.height = nHeight * this.SysPDF.nPdfFactor;
		// 	this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50Integrated.uiEindeckblechCol));
		// 	this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 	this.SysPDF.pdfMain.drawRect(rTmp);
		// 	this.SysPDF.pdfMain.endFill();
		// 	//Right
		// 	rTmp.x = (((vgroupTmp.x + vgroupTmp.width) - Sol50Integrated.nEindeckblechQS) + Sol50Integrated.nRandRight) * this.SysPDF.nPdfFactor;
		// 	rTmp.y = (vgroupTmp.y - (Sol50Integrated.nEindeckblechZusatz / 2)) * this.SysPDF.nPdfFactor;
		// 	rTmp.width = Sol50Integrated.nEindeckblechQS * this.SysPDF.nPdfFactor;
		// 	rTmp.height = nHeight * this.SysPDF.nPdfFactor;
		// 	this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50Integrated.uiEindeckblechCol));
		// 	this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 	this.SysPDF.pdfMain.drawRect(rTmp);
		// 	this.SysPDF.pdfMain.endFill();
		// }
	}
	//Oberes Abschlussblech zeichnen
	public static drawTopAbschlussblech(): void {
		// var i: number;
		// var vgroupTmp: VGroup;
		// var nY: number;
		// var nX: number;
		// var nWidth: number;
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	nX = vgroupTmp.x - (Sol50Integrated.nTopAbschlussblechZusatz / 2);
		// 	nY = vgroupTmp.y - Sol50Integrated.nRandTop;
		// 	nWidth = vgroupTmp.width + Sol50Integrated.nTopAbschlussblechZusatz;
		// 	this.Global.pageDesign.canFramework.graphics.beginFill(Sol50Integrated.uiTopAbschlussblechCol);
		// 	this.Global.pageDesign.canFramework.graphics.drawRect(nX, nY, nWidth, Sol50Integrated.nTopAbschlussblechQS);
		// 	this.Global.pageDesign.canFramework.graphics.endFill();
		// }
	}
	public static drawTopAbschlussblechPDF(): void {
		// var i: number;
		// var vgroupTmp: VGroup;
		// var nY: number;
		// var nX: number;
		// var nWidth: number;
		// var rTmp: Rectangle = new Rectangle();
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	nX = vgroupTmp.x - (Sol50Integrated.nTopAbschlussblechZusatz / 2);
		// 	nY = vgroupTmp.y - Sol50Integrated.nRandTop;
		// 	nWidth = vgroupTmp.width + Sol50Integrated.nTopAbschlussblechZusatz;
		// 	rTmp.x = nX * this.SysPDF.nPdfFactor;
		// 	rTmp.y = nY * this.SysPDF.nPdfFactor;
		// 	rTmp.width = nWidth * this.SysPDF.nPdfFactor;
		// 	rTmp.height = Sol50Integrated.nTopAbschlussblechQS * this.SysPDF.nPdfFactor;
		// 	this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50Integrated.uiTopAbschlussblechCol));
		// 	this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 	this.SysPDF.pdfMain.drawRect(rTmp);
		// 	this.SysPDF.pdfMain.endFill();
		// }
	}
	//Horizontalprofil zeichnen
	public static drawHProfil(): void {
		// var i: number, j: number;
		// var vgroupTmp: VGroup;
		// var nModHeight: number;
		// var nY: number;
		// var nHalfProfHeight: number;
		// nHalfProfHeight = (this.Sol50.nVertikalAbstand + Sol50Integrated.nHProfilHeight) / 2;
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	if (SC_Input.nModWidth == vgroupTmp.nModWith) {
		// 		nModHeight = SC_Input.nModHeight;
		// 	} else {
		// 		nModHeight = SC_Input.nModWidth;
		// 	}
		// 	for (j = 0; j < vgroupTmp.iCnt; j++) {
		// 		nY = vgroupTmp.y + (j * (nModHeight + this.Sol50.nVertikalAbstand));
		// 		this.Global.pageDesign.canFramework.graphics.beginFill(Sol50Integrated.uiHProfilCol);
		// 		this.Global.pageDesign.canFramework.graphics.drawRect(vgroupTmp.x, nY, vgroupTmp.width, Sol50Integrated.nHProfilHeight);
		// 		this.Global.pageDesign.canFramework.graphics.endFill();
		// 		if (this.MountingSystem.bMarkers) {
		// 			this.MountingSystem.markHLine(vgroupTmp.x, vgroupTmp.x + vgroupTmp.width, nY + nHalfProfHeight, Sol50Integrated.nHProfilLen);
		// 		}
		// 	}
		// 	//bottom
		// 	nY = vgroupTmp.y + (j * (nModHeight + this.Sol50.nVertikalAbstand));
		// 	this.Global.pageDesign.canFramework.graphics.beginFill(Sol50Integrated.uiHProfilCol);
		// 	this.Global.pageDesign.canFramework.graphics.drawRect(vgroupTmp.x, nY, vgroupTmp.width, Sol50Integrated.nHProfilHeight);
		// 	this.Global.pageDesign.canFramework.graphics.endFill();
		// 	if (this.MountingSystem.bMarkers) {
		// 		this.MountingSystem.markHLine(vgroupTmp.x, vgroupTmp.x + vgroupTmp.width, nY + nHalfProfHeight, Sol50Integrated.nHProfilLen);
		// 	}
		// }
	}
	public static drawHProfilPDF(): void {
		// var i: number, j: number;
		// var vgroupTmp: VGroup;
		// var nModHeight: number;
		// var nY: number;
		// var nHalfProfHeight: number;
		// var hprofilTmp: HLine;
		// var rTmp: Rectangle = new Rectangle();
		// nHalfProfHeight = Sol50Integrated.nHProfilHeight / 2;
		// for (i = 0; i < Sol50Integrated.aVGroups.length; i++) {
		// 	vgroupTmp = VGroup(Sol50Integrated.aVGroups[i]);
		// 	if (SC_Input.nModWidth == vgroupTmp.nModWith) {
		// 		nModHeight = SC_Input.nModHeight;
		// 	} else {
		// 		nModHeight = SC_Input.nModWidth;
		// 	}
		// 	for (j = 0; j < vgroupTmp.iCnt; j++) {
		// 		nY = vgroupTmp.y + (j * (nModHeight + this.Sol50.nVertikalAbstand));
		// 		rTmp.x = vgroupTmp.x * this.SysPDF.nPdfFactor;
		// 		rTmp.y = nY * this.SysPDF.nPdfFactor;
		// 		rTmp.width = vgroupTmp.width * this.SysPDF.nPdfFactor;
		// 		rTmp.height = Sol50Integrated.nHProfilHeight * this.SysPDF.nPdfFactor;
		// 		this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50Integrated.uiHProfilCol));
		// 		this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 		this.SysPDF.pdfMain.drawRect(rTmp);
		// 		this.SysPDF.pdfMain.endFill();
		// 		if (this.SysPDF.bMarkers) {
		// 			this.SysPDF.pdfMain.addText(i.toString(), rTmp.left, rTmp.y);
		// 			this.SysPDF.markHLine(rTmp.left, rTmp.right, rTmp.y + (nHalfProfHeight * this.SysPDF.nPdfFactor), Sol50Integrated.nHProfilLen * this.SysPDF.nPdfFactor);
		// 		}
		// 	}
		// 	//bottom
		// 	nY = vgroupTmp.y + (j * (nModHeight + this.Sol50.nVertikalAbstand));
		// 	rTmp.x = vgroupTmp.x * this.SysPDF.nPdfFactor;
		// 	rTmp.y = nY * this.SysPDF.nPdfFactor;
		// 	rTmp.width = vgroupTmp.width * this.SysPDF.nPdfFactor;
		// 	rTmp.height = Sol50Integrated.nHProfilHeight * this.SysPDF.nPdfFactor;
		// 	this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50Integrated.uiHProfilCol));
		// 	this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 	this.SysPDF.pdfMain.drawRect(rTmp);
		// 	this.SysPDF.pdfMain.endFill();
		// 	if (this.SysPDF.bMarkers) {
		// 		this.SysPDF.pdfMain.addText(i.toString(), rTmp.left, rTmp.y);
		// 		this.SysPDF.markHLine(rTmp.left, rTmp.right, rTmp.y + (nHalfProfHeight * this.SysPDF.nPdfFactor), Sol50Integrated.nHProfilLen * this.SysPDF.nPdfFactor);
		// 	}
		// }
	}
	//Gruppen bilden
	public static createGroups(): void {
		if (ModList.iCount < 1) {
			return;
		}
		Sol50Integrated.getHGroups();
		Sol50Integrated.getGroups();
		MountingSystem.bGroupsValid = Sol50Integrated.check_aVGroups();
	}
	
}
// }
